import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { registerSW } from 'virtual:pwa-register'
import { App } from './App'
import './index.css'

const container = document.getElementById('root')
if (!container) throw new Error('#root não encontrado')

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
)

// Cache offline: a página precisa funcionar em modo avião para que alguém possa
// auditá-la, desconectar e continuar usando. `autoUpdate` cuida das versões.
registerSW({ immediate: true })
